import {Overlay, OverlayConfig, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {ComponentRef, DestroyRef, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ZoidAppModalComponent} from '../../shared/components/zoid-app-modal/zoid-app-modal.component';

@Injectable({
    providedIn: 'root'
})
export class ZoidAppModalService {

    private overlayConfig: OverlayConfig = {};
    private appOverlays: { [key: string]: { overlayRef: OverlayRef, containerRef: ComponentRef<ZoidAppModalComponent> } } = {};

    constructor(
        private overlay: Overlay,
    ) {
        this.setOverlayConfig();
        this.createOverlay();
    }

    private setOverlayConfig() {
        const scrollStrategy = this.overlay.scrollStrategies.block();

        this.overlayConfig = {
            hasBackdrop: false,
            scrollStrategy,
        };
    }

    private createOverlay() {
        return this.overlay.create(this.overlayConfig);
    }

    public attach(appName: string) {
        if (Object.keys(this.appOverlays).includes(appName)) {
            return;
        }

        const overlayRef = this.createOverlay();
        overlayRef.hostElement.style.display = 'none'; // attach hidden
        const containerRef = overlayRef.attach(new ComponentPortal(ZoidAppModalComponent))

        containerRef.instance.appContainer = appName;

        this.appOverlays[appName] = {
            overlayRef,
            containerRef,
        }
    }

    public show(appName: string) {
      if (!this.appOverlays[appName]) {
        return;
      }
      this.appOverlays[appName].overlayRef.hostElement.style.display = 'block';
    }

    public hide(appName: string) {
      if (!this.appOverlays[appName]) {
        return;
      }
      this.appOverlays[appName].overlayRef.hostElement.style.display = 'none';
    }
}
